import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import Icon from "@mdi/react";
import { mdiLoading } from "@mdi/js";
import { connect } from "react-redux";
import axios from "axios";

import TileLayer      from "ol/layer/Tile.js";
import OSM from 'ol/source/OSM.js';
import Map            from "ol/Map.js";
import View           from "ol/View.js";
import { fromLonLat } from "ol/proj";

import Styles from "./ContactPanel.scss";
import InputFloatingStyle from "../../../../sass/floatingLabel.scss";

const ContactPanel = (props) => {
   const [isLoading, setIsLoading] = useState(false);
   const mapRef = useRef();
   const {
      register,
      handleSubmit,
      formState: { errors },
      reset,
   } = useForm({
      mode: "onChange",
      defaultValues: {
         msg: "",
         subject: "Demande d'information sur le site Urba Earth",
      },
   });

   useEffect(() => {
      buildMap();
   }, []);

   useEffect(() => { }, [isLoading]);

   const osm = new TileLayer({
      source: new OSM({
         // uncomment if you hit CORS issues:
         // crossOrigin: 'anonymous'
      }),
      title: 'OSM',
      visible: true,
      baseLayer: true,
   });
   const buildMap = () => {
      const mapObject = new Map({
         layers: [osm],
         view: new View({
            center: fromLonLat([8.737335, 41.922173]),
            zoom: 15,
            minZoom: 9,
            maxZoom: 18,
            rotation: 0,
         }),
      });

      mapObject.setTarget(mapRef.current);
   };

   const onSubmit = async (data) => {
      setIsLoading(true);
      try {
         const result = await axios.post("Api/contact", data);
         result.data.result === "ok"
            ? toast.success("Votre message à bien été envoyé  ! \n\nNous allons le traiter au plus vite !")
            : null;
      } catch (e) {
         toast.error("Un problème est survenu et vortre message n'a pas été envoyé !");
      }
      setIsLoading(false);
      reset();
   };

   return (
      <div className={"container-fluid text-dark w-100 h-100 ue-contact-panel "}>
         <div className={"row"} style={{ height: "100%" }}>
            <div className={"col-12 col-lg-6"}>
               <div className={"d-flex flex-column justify-content-start align-items-start w-100 h-100 p-5 bg-white"}>
                  {isLoading ? (
                     <div className="row vh-100 w-100">
                        <div className="col-12 justify-content-center align-items-center w-100">
                           <div className="text-center my-2 " data-testid="loading-spinner">
                              <Icon path={mdiLoading} spin={true} size={1} color={"var(--theme-primary"} />
                           </div>
                        </div>
                     </div>
                  ) : (
                     <>
                        <div
                           style={{
                              padding: "1rem 0",
                           }}
                        >
                           <h5
                              data-testid="main-title"
                              style={{
                                 fontWeight: "700",
                                 fontSize: "1.8rem",
                              }}
                           >
                              Contactez l'équipe Urba Earth
                           </h5>
                           <h3 className={""} style={{ fontWeight: "700" }}>
                              {" "}
                              Faites-nous part de vos remarques !
                           </h3>
                           <p className={""} style={{ fontWeight: "lighter" }}>
                              Nous reviendrons vers vous au plus vite.
                           </p>
                        </div>

                        <div className={"d-flex flex-column w-100 h-100 mb-5"}>
                           <form
                              data-testid="contact_form"
                              className={""}
                              onSubmit={handleSubmit(onSubmit)}
                              style={{
                                 maxWidth: "1000px",
                                 height: "100%",
                              }}
                           >
                              <div className="form-row mb-1">
                                 <div className="col-6 mb-1">
                                    <div className="did-floating-label-content">
                                       <input
                                          className="did-floating-input"
                                          type="text"
                                          id={"name"}
                                          data-testid={"name"}
                                          name={"name"}
                                          placeholder=" "
                                          defaultValue={props?.name ? props.name : ""}
                                          {...register("name", {
                                             required: true,
                                          })}
                                       ></input>
                                       <label className="did-floating-label">Nom</label>
                                    </div>
                                    {errors.name && (
                                       <span className="text-danger" data-testid="error-name" role="alert">
                                          Vous devez renseigner un nom
                                       </span>
                                    )}
                                 </div>
                                 <div className="col-6 mb-1">
                                    <div className="did-floating-label-content">
                                       <input
                                          className="did-floating-input"
                                          type="text"
                                          id={"forename"}
                                          data-testid={"forename"}
                                          name={"forename"}
                                          placeholder=" "
                                          defaultValue={props?.forename ? props.forename : ""}
                                          {...register("forename", {
                                             required: true,
                                          })}
                                       ></input>
                                       <label className="did-floating-label">Prénom</label>
                                    </div>

                                    {errors.forename && (
                                       <span className="text-danger" data-testid="error-forename" role="alert">
                                          Vous devez renseigner un prénom
                                       </span>
                                    )}
                                 </div>
                              </div>
                              <div className="form-row mb-2">
                                 <div className="col-12 ">
                                    <div className="did-floating-label-content">
                                       <input
                                          className="did-floating-input"
                                          type="text"
                                          id={"email"}
                                          data-testid={"email"}
                                          name={"email"}
                                          placeholder=" "
                                          defaultValue={props?.email ? props.email : ""}
                                          {...register("email", {
                                             required: true,
                                             pattern: {
                                                value: /\S+@\S+\.\S+/,
                                                message: "Le format de l'email est incorrect",
                                             },
                                          })}
                                       ></input>
                                       <label className="did-floating-label">Adresse mail</label>
                                    </div>
                                    {errors.email && (
                                       <span className="text-danger" data-testid="error-forename" role="alert">
                                          Vous devez renseigner un email valide
                                       </span>
                                    )}
                                 </div>
                              </div>
                              <div className="form-row">
                                 <div className="col-6 mb-1">
                                    <div className="did-floating-label-content">
                                       <input
                                          className="did-floating-input"
                                          type="text"
                                          id={"phone"}
                                          data-testid={"phone"}
                                          name={"phone"}
                                          placeholder=" "
                                          defaultValue={props?.phone ? props.phone : ""}
                                          {...register("phone")}
                                       ></input>
                                       <label className="did-floating-label">Tél fixe</label>
                                    </div>
                                 </div>

                                 <div className="col-6 mb-1">
                                    <div className="did-floating-label-content">
                                       <input
                                          className="did-floating-input"
                                          placeholder=" "
                                          type="text"
                                          id={"mobile"}
                                          name={"mobile"}
                                          defaultValue={props?.mobile ? props.mobile : ""}
                                          {...register("mobile")}
                                       ></input>
                                       <label className="did-floating-label">Tél mobile</label>
                                    </div>
                                 </div>
                              </div>
                              <div
                                 className="form-row mt-2 mb-1"
                                 // style={{ height: "50%" }}
                              >
                                 <div
                                    className="col-12 "
                                    // style={{ height: "100%" }}
                                 >
                                    <div className="did-floating-label-content">
                                       <input
                                          className="did-floating-input"
                                          placeholder=" "
                                          style={{
                                             minHeight: "200px",
                                             backgroundColor: "#F9F9F9",
                                             border: "none",
                                          }}
                                          id={"msg"}
                                          data-testid={"msg"}
                                          name={"msg"}
                                          defaultValue={""}
                                          {...register("msg", {
                                             required: true,
                                          })}
                                       ></input>
                                       <label className="did-floating-label">Texte</label>
                                    </div>
                                    {errors.msg && (
                                       <span className="text-danger" data-testid="error-message" role="alert">
                                          Vous devez renseigner un message
                                       </span>
                                    )}
                                 </div>
                              </div>
                              <div className={"d-flex flex-row justify-content-between align-items-center mt-3"}>
                                 <div className={"d-flex  justify-content-start align-items-center "}>
                                    <div className={"mx-1"} id={"facebook_btn"} style={{ color: "#1768ab" }}>
                                       <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          x="0px"
                                          y="0px"
                                          width="30px"
                                          height="30px"
                                          viewBox="0 0 48 48"
                                       >
                                          <linearGradient
                                             id="awSgIinfw5_FS5MLHI~A9a_yGcWL8copNNQ_gr1"
                                             x1="6.228"
                                             x2="42.077"
                                             y1="4.896"
                                             y2="43.432"
                                             gradientUnits="userSpaceOnUse"
                                          >
                                             <stop offset="0" stopColor="#0d61a9"></stop>
                                             <stop offset="1" stopColor="#16528c"></stop>
                                          </linearGradient>
                                          <path
                                             fill="url(#awSgIinfw5_FS5MLHI~A9a_yGcWL8copNNQ_gr1)"
                                             d="M42,40c0,1.105-0.895,2-2,2H8c-1.105,0-2-0.895-2-2V8c0-1.105,0.895-2,2-2h32	c1.105,0,2,0.895,2,2V40z"
                                          ></path>
                                          <path
                                             d="M25,38V27h-4v-6h4v-2.138c0-5.042,2.666-7.818,7.505-7.818c1.995,0,3.077,0.14,3.598,0.208	l0.858,0.111L37,12.224L37,17h-3.635C32.237,17,32,18.378,32,19.535V21h4.723l-0.928,6H32v11H25z"
                                             opacity=".05"
                                          ></path>
                                          <path
                                             d="M25.5,37.5v-11h-4v-5h4v-2.638c0-4.788,2.422-7.318,7.005-7.318c1.971,0,3.03,0.138,3.54,0.204	l0.436,0.057l0.02,0.442V16.5h-3.135c-1.623,0-1.865,1.901-1.865,3.035V21.5h4.64l-0.773,5H31.5v11H25.5z"
                                             opacity=".07"
                                          ></path>
                                          <path
                                             fill="#fff"
                                             d="M33.365,16H36v-3.754c-0.492-0.064-1.531-0.203-3.495-0.203c-4.101,0-6.505,2.08-6.505,6.819V22h-4v4	h4v11h5V26h3.938l0.618-4H31v-2.465C31,17.661,31.612,16,33.365,16z"
                                          ></path>
                                       </svg>
                                    </div>
                                    <div
                                       className={"mx-1 "}
                                       id={"tweeter_btn"}
                                       style={{
                                          color: "#FFF",
                                          backgroundColor: "rgb(81 169 235)",
                                          padding: "2px",
                                       }}
                                    >
                                       <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="20"
                                          fill="currentColor"
                                          className="bi bi-twitter"
                                          viewBox="0 0 16 16"
                                       >
                                          <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0 0 16 3.542a6.658 6.658 0 0 1-1.889.518 3.301 3.301 0 0 0 1.447-1.817 6.533 6.533 0 0 1-2.087.793A3.286 3.286 0 0 0 7.875 6.03a9.325 9.325 0 0 1-6.767-3.429 3.289 3.289 0 0 0 1.018 4.382A3.323 3.323 0 0 1 .64 6.575v.045a3.288 3.288 0 0 0 2.632 3.218 3.203 3.203 0 0 1-.865.115 3.23 3.23 0 0 1-.614-.057 3.283 3.283 0 0 0 3.067 2.277A6.588 6.588 0 0 1 .78 13.58a6.32 6.32 0 0 1-.78-.045A9.344 9.344 0 0 0 5.026 15z" />
                                       </svg>
                                    </div>
                                    <div className={"mx-1"} id={"linkdin_btn"} style={{ color: "#0046d3" }}>
                                       <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          fill="currentColor"
                                          className="bi bi-linkedin"
                                          viewBox="0 0 16 16"
                                       >
                                          <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z" />
                                       </svg>
                                    </div>
                                 </div>
                                 <button className={"btn btn-primary text-white font-weight-bold"} type="submit">
                                    ENVOYER
                                 </button>
                              </div>
                           </form>
                        </div>
                     </>
                  )}
               </div>
            </div>
            <div className={"col-12 col-lg-6 w-100 h-100"}>
               <div className={"d-flex flex-column align-items-start w-100 h-100 p-5 bg-white"}>
                  <div id={"ue_map-loc"} className={"w-100 h-75 mb-4"}>
                     <div ref={mapRef} id={"ue_contactlocalize"} />
                  </div>
                  <div className={"d-flex flex-column ml-5"} style={{ fontSize: "12px", lineHeight: "27px" }}>
                     <div style={{ color: "#888" }}>
                        <span className={"font-weight-bold"} style={{ color: "#000" }}>
                           Adresse :{" "}
                        </span>
                        14 Rue Conventionnel Chiappe, 20000 Ajaccio
                     </div>
                     <div style={{ color: "#888" }}>
                        <span className={"font-weight-bold"} style={{ color: "#000" }}>
                           Horaires :{" "}
                        </span>{" "}
                        09:00 à 18:00 du Lundi au Vendredi
                     </div>
                     <div style={{ color: "#888" }}>
                        <span className={"font-weight-bold"} style={{ color: "#000" }}>
                           Site web :{" "}
                        </span>{" "}
                        urba-earth.com
                     </div>
                     <div style={{ color: "#888" }}>
                        <span className={"font-weight-bold"} style={{ color: "#000" }}>
                           Courriel :
                        </span>{" "}
                        contact@urba-earth.com
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      userId: state.MeReducer.id,
      entity: state.MeReducer.entity,
      email: state.MeReducer.email,
      name: state.MeReducer.name,
      username: state.MeReducer.username,
      structureInfo: state.SubscribtionReducer.structureInfo,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      updateStructureInfo: (e) => dispatch({ type: "UPDATE_STRUCTURE_INFO", data: e }),
      updateUserInfo: (e) => dispatch({ type: "UPDATE_USER_STATUS", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(ContactPanel);
